export default __webpack_public_path__ + "static/media/viva-la-vida.70afca6f.jpg";